import { render, staticRenderFns } from "./basic-info.vue?vue&type=template&id=c7b5f198&scoped=true&"
import script from "./basic-info.vue?vue&type=script&lang=js&"
export * from "./basic-info.vue?vue&type=script&lang=js&"
import style0 from "./basic-info.vue?vue&type=style&index=0&id=c7b5f198&prod&lang=css&"
import style1 from "./basic-info.vue?vue&type=style&index=1&id=c7b5f198&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b5f198",
  null
  
)

export default component.exports